module.exports = __webpack_public_path__ + "media/images/davky-b5668164aba816f4973f390bf2853794.png";